// Enlaces de WhatsApp click-to-chat. Mismo criterio que manager.lealify.com (phoneUtils.ts):
// móvil → esquema whatsapp://  ·  escritorio → web.whatsapp.com/send. Normaliza MX a 521+10.

/** Normaliza prefijo+número a formato WhatsApp (solo dígitos, MX → 521+10). '' si inválido. */
export function normalizeWa(prefix: string | null, number: string | null): string {
  if (!number) return '';
  let n = `${prefix || ''}${number || ''}`.replace(/\D/g, '').replace(/^\+/, '');
  if (!n) return '';
  if (n.length === 12 && n.startsWith('52') && !n.startsWith('521')) {
    n = '521' + n.substring(2);           // 52 + 10 → 521 + 10
  } else if (n.length === 10 && /^[2-9]/.test(n)) {
    n = '521' + n;                         // 10 sueltos → 521 + 10
  }
  return n;
}

export function isMobile(): boolean {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    typeof navigator !== 'undefined' ? navigator.userAgent : ''
  );
}

/** Enlace de WhatsApp para iniciar chat con mensaje precargado. '' si el número es inválido. */
export function getWhatsAppLink(prefix: string | null, number: string | null, message = ''): string {
  const wa = normalizeWa(prefix, number);
  if (!wa) return '';
  const text = encodeURIComponent(message);
  return isMobile()
    ? `whatsapp://send?phone=${wa}&text=${text}`
    : `https://web.whatsapp.com/send?phone=${wa}&text=${text}`;
}

/** Reemplaza variables de plantilla. Hoy: {nombre} (primer nombre). */
export function fillTemplate(tpl: string, vars: { nombre?: string; apellido?: string; edad?: string | number }): string {
  return tpl
    .replace(/\{nombre\}/g, vars.nombre || '')
    .replace(/\{apellido\}/g, vars.apellido || '')
    .replace(/\{edad\}/g, vars.edad != null ? String(vars.edad) : '');
}

/** Variables disponibles para el editor de plantillas (chips). */
export const TEMPLATE_VARS = [
  { token: '{nombre}', label: 'Nombre' },
  { token: '{apellido}', label: 'Apellido' },
  { token: '{edad}', label: 'Edad' },
];
